import { t } from "i18next";
import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { LANGUAGE, MODAL_BODY } from "../../constants/constant";
import {
  clearChatSlice,
  exitChat,
  setGetPollIntervalId,
} from "../../redux/slices/ChatSlice/chatSlice";
import { clearFormSlice } from "../../redux/slices/FormSlice/formSlice";
import { getLanguage } from "../../util/UtilMethods";

const ThankYouView = (props) => {
  const { setModalBody } = props;
  const dispatch = useDispatch();

  const { participantId, intervalId } = useSelector((state) => state.chat);

  const handleEndSession = () => {
    dispatch(exitChat(participantId));
    dispatch(setGetPollIntervalId(""));
    clearInterval(intervalId);
    dispatch(clearFormSlice());
    dispatch(clearChatSlice());
  };

  const handleExitChat = () => {
    handleEndSession();
    setModalBody(MODAL_BODY.FORM);
  };

  const handleFeedbackClick = () => {
    dispatch(exitChat(participantId));
    dispatch(setGetPollIntervalId(""));
    clearInterval(intervalId);
    setModalBody(MODAL_BODY.FEEDBACK);
  };

  return (
    <div id="thankYou">
      <div className={`thank-you-container p-5 ${
          LANGUAGE.ENGLISH === getLanguage() ? "ltr" : "rtl"
        }`}>
        <h5 className="mb-4">{t("thank_you_message")}</h5>
        <div className="d-flex chat-form-btns justify-content-center">
          <button
            className="btn blue btn-feedback mx-1"
            onClick={() => setModalBody(MODAL_BODY.LIVE_CHAT)}
          >
            {t("back_to_chat")}
          </button>
          <button
            className="button btn-danger bg-danger btn-feedback mx-1"
            onClick={() => handleFeedbackClick()}
          >
            {t("customer_satisfaction_survey")}
          </button>
          <button
            className="button btn-danger bg-danger btn-feedback mx-1"
            onClick={() => handleExitChat()}
          >
            {t("end_session")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouView;
